// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "table[data-v-68eb79a7]{border-bottom:1px solid rgba(0,0,0,.12)}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/shared/OrderIndividualInfoSingleDialog.vue"],"names":[],"mappings":"AACA,uBACC,uCAAA","file":"OrderIndividualInfoSingleDialog.vue","sourcesContent":["\ntable {\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n"]}]);
// Exports
module.exports = exports;
